import { render, staticRenderFns } from "./ManualRewardModal.vue?vue&type=template&id=55bc23be"
import script from "./ManualRewardModal.vue?vue&type=script&lang=js"
export * from "./ManualRewardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports